import React, { useEffect } from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { trackMetaEvent, trackTikTokEvent } from 'util/analytics';

const ThankYouPayout = (props) => {

     const location = useLocation();
    // useEffect(() => {
    //     ReactGA.initialize('UA-157984080-1');
    //     ReactGA.pageview(window.location.pathname + window.location.search);
    //     
    //     ReactPixel.init('197333187452630');
    //     ReactPixel.track('Purchase', { value: props.location.state.pay_amount, currency: props.location.state.currency });
    // }, []);

  useEffect(() => {
    // Get payment details from URL params
    const urlParams = new URLSearchParams(location.search);
    const amount = urlParams.get('p') || '0.00';
    const currency = urlParams.get('currency') || 'AUD';
    const productName = urlParams.get('product_name') || 'Subscription Plan';
    const productId = urlParams.get('product_id') || 'subscription_001';

    // Track Purchase conversion using helper functions
    trackMetaEvent('Purchase', { 
      value: parseFloat(amount), 
      currency: currency 
    });
    trackTikTokEvent('PlaceAnOrder', {
    contents: [
      {
        content_id: productId,
        content_type: "product",
        content_name: productName,
        quantity: 1,
        price: parseFloat(amount)
      }
    ],
    value: parseFloat(amount),
    currency: currency
  });
  }, [location.search]);

    return (
        <React.Fragment>
            <Helmet htmlAttributes>
                <title>Language Academy</title>
            </Helmet>
            <Header />
            <div className="innerPage thankyouPayoutBnr">
                <section className="bannerOuter">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 text-center">
                                <div className="thankyou-inner">
                                    <h2 className="header"><b><i className="fa fa-check-circle" aria-hidden="true"></i> &nbsp;&nbsp;Thank You!</b></h2>
                                    <p>Your Payment Received successfully<br />
                                    </p>
                                </div>
                                <span></span><br />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <section id="pte-modules" className="mt-5">
                <div className="container">
                    <div className="row text-center">
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    );
};

export default ThankYouPayout;